<template>
  <div>
    <v-client-table
      id="audit-change-log-table"
      :columns="columns"
      :data="rows"
      :options="options"
      :theme="theme"
      class="w-100"
    >
      <span slot="identifier" slot-scope="{ row }">
        <router-link v-if="getRouteRoute(row.identifier.data_type)" :to="`${getRouteRoute(row.identifier.data_type)}/${row.identifier.id}`">
          {{ row.identifier.publicNumber }}
        </router-link>
        <span v-else>{{ row.identifier.publicNumber }}</span>
      </span>
    </v-client-table>
  </div>
</template>

<script>
import Vue from 'vue'
import { ClientTable } from 'vue-tables-2'
import moment from 'moment'

Vue.use(ClientTable)

export default {
  name: 'AuditRelationTable',
  components: {
    ClientTable
  },
  props: {
    model: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      columns: [
        'action',
        'identifier',
        'added',
        'added_by',
        'updated',
        'updated_by'
      ],
      options: {
        filterable: []
      },
      theme: 'bootstrap4',
    }
  },
  computed: {
    rows () {
      return this.model && Object.keys(this.model.attributes).map(key => {
        if (this.lodash.isObject(this.model[key]) && !this.lodash.isArray(this.model[key]) && !key.includes('_by') && !key.includes('_log') && !key.includes('_schedules')) {
          let action = key
          let identifier = {
            data_type: key,
            publicNumber: this.model[key].publicNumber ? this.model[key].publicNumber() : this.model[key].pid || this.model[key].name || this.model[key].full_name || this.model[key].first_name || '-',
            id: this.model[key].id
          }
          let added = this.model[key].created_at ? moment(this.model[key].created_at).format("YYYY-MM-DD HH:mm:ss") : '-'
          let added_by = this.model[key].created_by || '-'
          let updated = this.model[key].updated_at ? moment(this.model[key].updated_at).format("YYYY-MM-DD HH:mm:ss") : '-'
          let updated_by = this.model[key].updated_by || '-'

          return {
            action: this.lodash.startCase(action),
            identifier,
            added,
            added_by,
            updated,
            updated_by
          }
        }
      }).filter(Boolean) || []
    }
  },
  methods: {
    getRouteRoute (data_type) {
      switch (data_type) {
        case 'sample_type':
          return '/sampletypes'
        case 'customer':
          return '/customer'
        case 'customer_contact':
          return null
        case 'laboratory':
          return '/laboratory'
        case 'test_package':
          return '/testpackages'
        default:
          return `/${data_type}s`
      }
    }
  }
}
</script>
